<h1 mat-dialog-title>
  {{ title }}
</h1>

<button mat-icon-button mat-dialog-close>
  <mat-icon>close</mat-icon>
</button>

<mat-horizontal-stepper [linear]="!isEdit" #stepper (selectionChange)="onStepChange($event)">
  <mat-step [stepControl]="formCondutor.form">
    <ng-template matStepLabel>Dados Pessoais</ng-template>
    <app-form [campos]="camposDadosPessoa" appearance="outline" #formCondutor></app-form>
  </mat-step>

  <mat-step [stepControl]="formCNH.form">
    <ng-template matStepLabel>Dados CNH</ng-template>
    <app-form [campos]="camposDadosCNH" appearance="outline" #formCNH></app-form>
  </mat-step>

  <mat-step [stepControl]="formEndereco.form">
    <ng-template matStepLabel>Endereço</ng-template>
    <app-form [campos]="camposEndereco" appearance="outline" #formEndereco></app-form>
  </mat-step>

  <mat-step [stepControl]="formContato.form">
    <ng-template matStepLabel>Contato</ng-template>
    <app-form [campos]="camposContato" appearance="outline" #formContato></app-form>
  </mat-step>

  <mat-step [stepControl]="formCNH.form" *ngIf="isEdit">
    <ng-template matStepLabel>Anexos</ng-template>
    <app-anexos [options]="anexosOptions" #anexos></app-anexos>
  </mat-step>
</mat-horizontal-stepper>


<div mat-dialog-actions align="end">
  <app-ellipsis-animation class="loading" *ngIf="loading" />

  <button type="button" mat-flat-button (click)="stepper.previous()" *ngIf="stepper.selectedIndex !== 0">
      Anterior
  </button>

  <button 
    type="button" 
    mat-flat-button 
    [disabled]="!stepper.selected?.stepControl?.valid" 
    (click)="stepper.next()" 
    *ngIf="stepper.selectedIndex < stepper.steps.length -1">
      Próximo
  </button>

<button 
    type="submit" 
    mat-flat-button 
    [disabled]="!isFormValid" 
    (click)="onSubmit(formCondutor.values, formCNH?.values, formEndereco?.values, formContato?.values)" 
    *ngIf="stepper.selectedIndex === stepper.steps.length -1">
      Salvar
  </button>
</div>